export default __webpack_public_path__ + "static/52-0f16e231aebb01da098bc5ecd45b6ec9.png";